import FJTextStyle from './FJTextStyle';
import FJShadow from './style/FJShadow';

class FJTextStyleShadow extends FJTextStyle {
    initStyles(props = {}) {
        let shadow = new FJShadow({
            ...props,
            color: '#000000',
            offset: 10,
            blur: 0,
            angle: 95,
            opacity: 35,
            position: 'relative',
        });

        this._styles = [shadow];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: *, offset: *, blur: *, opacity: *, direction: *}}
     */
    getAdjustInfo() {
        let shadow = this._styles[0];
        return {
            color: [shadow.color],
            blur: shadow.blur,
            opacity: shadow.opacity,
            offset: shadow.offset * 2,
            direction: shadow.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        info.color.forEach((color, index) => {
            if (color !== '') this._styles[index].color = color;
        });
        if (info.blur !== '') this._styles[0].blur = info.blur;

        if (info.offset !== '') this._styles[0].offset = info.offset / 2;

        if (info.opacity !== '') this._styles[0].opacity = info.opacity;

        if (info.direction !== '') this._styles[0].angle = info.direction;
    }
}

export default FJTextStyleShadow;
